import { allModelsSelector, singleModelSelector } from 'common-src/utils/selectorUtils';

export const getPatientFamilyHistory = (state, patientId) =>
  allModelsSelector(state, 'PatientFamilyHistory', (pmp) => pmp.patientId === patientId);

export const getPatientSingleFamilyHistory = (state, id) =>
  singleModelSelector(state, 'PatientFamilyHistory', id);
